import React from 'react'
import { useAppSelector } from '../../shared/redux/hooks'
import PropertyUtilitiesAndTaxesPanel from './PropertyUtilitiesAndTaxesPanel'
import PropertyProgramsPanel from './PropertyProgramsPanel'

interface PropertyDetailPanelsProps {
  propertyId: string
  propertyName?: string
}

/**
 * Property-level panels shown below the tenants table when a property is selected on the
 * Tenants screen (coworker feedback: Utilities and Taxes moved here from the program detail
 * page, alongside a place for other property-level info like the programs at this property).
 */
const PropertyDetailPanels: React.FC<PropertyDetailPanelsProps> = ({ propertyId, propertyName }) => {
  const { permissions } = useAppSelector((state) => state.app)

  // TODO(WEB-7242): 'program:manager:utilities:modify' doesn't exist in Auth0 yet, so no real
  // user has it. Hardcoded to true for now so the mocked Utilities and Taxes panel is visible
  // and demoable; switch back to permissions.includes(...) once the scope is rolled out.
  const canModifyUtilities = true || permissions?.includes('program:manager:utilities:modify')

  return (
    <div className="space-y-5">
      <PropertyUtilitiesAndTaxesPanel propertyId={propertyId} propertyName={propertyName} canModify={canModifyUtilities} />
      <PropertyProgramsPanel propertyId={propertyId} />
    </div>
  )
}

export default PropertyDetailPanels
